import { Button } from "antd";
import React from "react";
import localize from "../../../core/utils/translation-files";
import RenderSvg from "../icons/RenderSvg";
const PrintButton = ({ printOnClick, printBtnType = "default" }) => (React.createElement(Button, { type: printBtnType, onClick: printOnClick, id: "printBtn" },
    React.createElement(RenderSvg, { icon: "Print" }),
    localize(["print"])));
export default PrintButton;
